/* ==========================================================================
   COMMONSKLAD — bundle page (sections/cs-bundle-product.liquid)
   Two products, each chosen on its own: colour and size as on any product page,
   with no size chosen for the visitor. Once both are complete their two
   selections are one variant of the bundle (the pairing's own real variant),
   which Shopify is asked for and which goes in the form's [name=id], where the
   bag and "Худалдан авах" read it. Until then neither button can buy.
   ========================================================================== */
(() => {
  const qs = (selector, root) => root.querySelector(selector);
  const qsa = (selector, root) => Array.from(root.querySelectorAll(selector));

  function setup(root) {
    const form = qs('[data-cs-bundle-form]', root);
    const dataEl = qs('[data-cs-bundle-data]', root);
    if (!form || !dataEl || form.__csBundle) return;
    form.__csBundle = true;
    const data = JSON.parse(dataEl.textContent);
    const strings = data.strings;

    const input = qs('[data-cs-bundle-id]', form);
    const addBtn = qs('[data-cs-add-button]', form);
    const addLabel = qs('[data-cs-add-label]', form);
    const addPrice = qs('[data-cs-add-price]', form);
    const errorEl = qs('[data-cs-form-error]', form);
    const qtyInput = qs('[data-cs-qty-input]', form);
    const buyLink = qs('a[data-cs-buynow]', form);

    const items = qsa('[data-cs-bundle-item]', form).map((el, index) => ({
      el,
      groups: qsa('[data-cs-option-group]', el),
      picked: qs('[data-cs-bundle-picked]', el),
      thumb: qs('[data-cs-bundle-thumb]', el),
      variants: data.items[index].variants,
      values: data.items[index].values,
    }));

    const chosen = (item) => item.groups.map((group) => {
      const on = qs('.cs-opt.is-selected', group);
      return on ? on.dataset.value : null;
    });
    const complete = (item) => chosen(item).every((value) => value !== null);
    const variantOf = (item) => {
      const options = chosen(item);
      return item.variants.find((v) => v.options.every((value, k) => value === options[k])) || null;
    };

    /* -------------------------------------------------------------- values */
    const select = (btn) => {
      qsa('.cs-opt', btn.closest('[data-cs-option-group]')).forEach((other) => {
        const on = other === btn;
        other.classList.toggle('is-selected', on);
        other.setAttribute('aria-checked', on ? 'true' : 'false');
        other.tabIndex = on ? 0 : -1;
      });
    };

    // no size is chosen for the visitor, unless there is only the one
    items.forEach((item) => {
      item.groups.filter((group) => group.dataset.kind === 'size').forEach((group) => {
        const values = qsa('.cs-opt', group);
        if (values.length < 2) return;
        values.forEach((btn, index) => {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-checked', 'false');
          btn.tabIndex = index === 0 ? 0 : -1;
        });
      });
    });

    // with the other options as chosen, can this value be had?
    const markAvailability = (item) => {
      const options = chosen(item);
      const anyAvailable = item.variants.some((v) => v.available);
      item.groups.forEach((group, gi) => {
        const isColor = group.dataset.kind === 'color';
        qsa('.cs-opt', group).forEach((btn) => {
          const value = btn.dataset.value;
          if (isColor) {
            // a colour stays choosable; it is only marked
            const any = item.variants.some((v) => v.available && v.options[gi] === value);
            btn.classList.toggle('is-soldout', !any && anyAvailable);
            return;
          }
          const ok = item.variants.some((v) => v.available && v.options[gi] === value
            && v.options.every((o, k) => k === gi || options[k] === null || o === options[k]));
          const off = !ok && anyAvailable;
          btn.classList.toggle('is-unavailable', off);
          btn.setAttribute('aria-disabled', off ? 'true' : 'false');
        });
      });
    };

    const showItem = (item) => {
      const options = chosen(item);
      item.el.classList.toggle('is-complete', complete(item));
      item.picked.textContent = options.filter(Boolean).join(' / ');
      if (!item.thumb) return;
      // the photograph follows the colour, whatever the size
      const color = item.groups.findIndex((group) => group.dataset.kind === 'color');
      if (color < 0 || options[color] === item.color) return;
      const first = item.color === undefined;
      item.color = options[color];
      if (first) return;
      const match = item.variants.find((v) => v.options[color] === item.color && v.image);
      if (match) {
        item.thumb.removeAttribute('srcset');
        item.thumb.src = match.image;
      }
    };

    /* ------------------------------------------------------------- the id */
    let resolved = null; // the bundle's variant for what is chosen now
    let asking = null; // the request under way, while there is one
    let controller = null;

    const setError = (text) => {
      if (!errorEl) return;
      errorEl.textContent = text || '';
      errorEl.hidden = !text;
    };

    const setButton = (state) => {
      if (state === 'choose') addBtn.dataset.state = 'choose';
      else delete addBtn.dataset.state;
      const off = state === 'soldout' || state === 'missing';
      addBtn.disabled = off;
      addLabel.textContent = state === 'soldout' ? strings.soldOut : state === 'missing' ? strings.unavailable : strings.addToBag;
      addPrice.hidden = off;
      if (buyLink) buyLink.classList.toggle('is-off', off);
    };

    const fetchVariant = async (titles) => {
      const ids = titles.map((title, index) => items[index].values[title]);
      if (ids.some((id) => !id)) return null;
      if (controller) controller.abort();
      controller = new AbortController();
      const url = `${data.url}?section_id=cs-bundle-resolve&option_values=${ids.join(',')}`;
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const found = JSON.parse(qs('[data-cs-bundle-variant]', doc).textContent);
      // Shopify may offer the nearest variant for a pair that has none
      return found && titles.every((title, index) => found.options[index] === title) ? found : null;
    };

    const refresh = () => {
      resolved = null;
      asking = null;
      if (controller) controller.abort();
      setError('');
      items.forEach((item) => { markAvailability(item); showItem(item); });

      if (!items.every(complete)) { setButton('choose'); return; }
      const parts = items.map(variantOf);
      if (parts.some((part) => !part)) { setButton('missing'); setError(strings.missing); return; }
      if (parts.some((part) => !part.available)) { setButton('soldout'); return; }

      setButton('ready');
      const titles = parts.map((part) => part.title);
      const request = fetchVariant(titles).then((variant) => {
        if (request !== asking) return;
        asking = null;
        if (variant && variant.available) {
          resolved = variant;
          input.value = String(variant.id);
        } else {
          setButton(variant ? 'soldout' : 'missing');
          if (!variant) setError(strings.missing);
        }
      }).catch((error) => {
        if (error.name === 'AbortError' || request !== asking) return;
        asking = null;
        setError(strings.failed);
      });
      asking = request;
    };

    /* ------------------------------------------------------ what's missing */
    let asked = 0;
    const ask = () => {
      for (let i = 0; i < items.length; i += 1) {
        const group = items[i].groups.find((g) => !qs('.cs-opt.is-selected', g));
        if (group) {
          const option = group.closest('.cs-pdp__option');
          const first = qsa('.cs-opt', group).find((btn) => !btn.classList.contains('is-unavailable')) || qs('.cs-opt', group);
          setError(strings.choose);
          option.scrollIntoView({ block: 'center', behavior: 'smooth' });
          if (first) first.focus({ preventScroll: true });
          option.classList.add('is-asked');
          window.clearTimeout(asked);
          asked = window.setTimeout(() => option.classList.remove('is-asked'), 1600);
          return;
        }
      }
    };

    // the id, once it has come: the press that beat the answer waits for it
    const ready = async () => {
      if (!items.every(complete)) { ask(); return false; }
      if (!resolved && !asking) refresh(); // the last answer never came
      if (asking) await asking;
      return !!resolved;
    };

    /* ------------------------------------------------------------ pressing */
    form.addEventListener('click', (event) => {
      const btn = event.target.closest('.cs-opt');
      if (btn && btn.closest('[data-cs-option-group]')) {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        select(btn);
        refresh();
        return;
      }
      const step = event.target.closest('[data-cs-qty-step]');
      if (step && qtyInput) {
        qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(step.dataset.csQtyStep, 10)));
      }
    });

    // arrows move along the values, as on the product page
    form.addEventListener('keydown', (event) => {
      const btn = event.target.closest('.cs-opt');
      if (!btn || !['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) return;
      const values = qsa('.cs-opt', btn.closest('[data-cs-option-group]'));
      const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      const next = values[(values.indexOf(btn) + (forward ? 1 : -1) + values.length) % values.length];
      event.preventDefault();
      next.focus();
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', () => {
        qtyInput.value = String(Math.max(1, parseInt(qtyInput.value, 10) || 1));
      });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addBtn.getAttribute('aria-busy') === 'true') return;
      setError('');
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.disabled = true;
      try {
        if (!(await ready())) {
          addBtn.removeAttribute('aria-busy');
          addBtn.disabled = false;
          if (items.every(complete) && errorEl.hidden) setError(strings.failed);
          return;
        }
        await window.CS.cart.add([{ id: resolved.id, quantity: parseInt(qtyInput.value, 10) || 1 }], addBtn);
        addBtn.removeAttribute('aria-busy');
        addBtn.classList.add('is-added');
        window.setTimeout(() => {
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
        }, 1400);
      } catch (error) {
        addBtn.removeAttribute('aria-busy');
        addBtn.disabled = false;
        setError((error && error.message) || strings.failed);
      }
    });

    // this runs before the link's own handler, which then reads [name=id]
    if (buyLink) {
      buyLink.addEventListener('click', (event) => {
        if (resolved) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        ready().then((ok) => {
          if (ok) buyLink.click();
          else if (items.every(complete) && errorEl.hidden) setError(strings.failed);
        });
      }, true);
    }

    refresh();
  }

  const init = (scope) => qsa('[data-cs-bundle-product]', scope).forEach(setup);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
